import { Check, X, Minus } from "@/icons";
import type { ServiceComparisonRow } from "@/types/detail";

/** Comparison table: Spreadsheet vs Generic software vs VibeWell custom. */
export function ServiceComparisonTable({ rows }: { rows: ServiceComparisonRow[] }) {
  const cols = [
    { key: "spreadsheet" as const, label: "Spreadsheets", tone: "muted" },
    { key: "generic" as const, label: "Generic Software", tone: "muted" },
    { key: "vibewell" as const, label: "VibeWell Custom", tone: "brand" },
  ];

  return (
    <div className="overflow-hidden rounded-[1.25rem] border border-border bg-card">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse text-left">
          <thead>
            <tr className="border-b border-border">
              <th className="p-5 text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                Capability
              </th>
              {cols.map((c) => (
                <th
                  key={c.key}
                  className={
                    "p-5 font-heading text-sm font-semibold " +
                    (c.tone === "brand" ? "bg-primary/[0.06] text-primary" : "text-foreground")
                  }
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.aspect} className="border-b border-border last:border-0">
                <td className="p-5 align-top text-sm font-medium text-foreground">
                  {row.aspect}
                </td>
                {cols.map((c) => {
                  const value = row[c.key];
                  const isBrand = c.tone === "brand";
                  const Icon = isBrand ? Check : c.key === "spreadsheet" ? X : Minus;
                  const iconColor = isBrand
                    ? "text-primary"
                    : c.key === "spreadsheet"
                      ? "text-danger/70"
                      : "text-warning";
                  return (
                    <td
                      key={c.key}
                      className={
                        "p-5 align-top text-sm text-muted-foreground " +
                        (isBrand ? "bg-primary/[0.04]" : "")
                      }
                    >
                      <span className="flex items-start gap-2">
                        <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${iconColor}`} />
                        <span className={isBrand ? "text-foreground" : ""}>{value}</span>
                      </span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
